import script from "./FloatingLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingLinks.vue?vue&type=script&setup=true&lang=js"

import "./FloatingLinks.vue?vue&type=style&index=0&id=b53bf606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b53bf606"]])

export default __exports__